import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css, keyframes } from 'styled-components';
import { useMeasure } from '@hivebrite/react-hooks';
import { Box } from "../../box/src";
export const ZoomOut = (_a) => {
    var { children, childrenHeight, dataTestId, frameWidth } = _a, boxProps = __rest(_a, ["children", "childrenHeight", "dataTestId", "frameWidth"]);
    const [ref, { height: wrapperRef }] = useMeasure();
    const shouldScroll = childrenHeight > wrapperRef;
    return (_jsx(ZoomOutWrapper, Object.assign({}, boxProps, { "$childrenHeight": `${Math.round(childrenHeight)}px`, "$frameWidth": frameWidth, "$shouldScroll": shouldScroll, "data-testid": dataTestId, ref: ref, children: children })));
};
const scrollEffect = ($childrenHeight) => keyframes `
    from {
      top: 0;
    }
    to {
      top: calc(100% - ${$childrenHeight})
    }
    `;
const scrollAnimationOnHover = ($childrenHeight) => css `
  &:hover {
    animation: ${scrollEffect($childrenHeight)} 5s ease;
    animation-fill-mode: forwards;
  }
`;
const ZoomOutWrapper = styled(Box).attrs((_a) => {
    var { $frameWidth } = _a, boxProps = __rest(_a, ["$frameWidth"]);
    return (Object.assign(Object.assign({}, boxProps), { alignItems: 'center', borderRadius: '10px', display: 'flex', height: '100%', justifyContent: 'center', overflow: 'auto', position: 'relative', width: $frameWidth ? `${$frameWidth}px` : '100%' }));
}) `
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  & > * {
    top: 0;
    position: absolute;
    ${({ $childrenHeight, $shouldScroll }) => $shouldScroll && scrollAnimationOnHover($childrenHeight)}
  }
`;
//# sourceMappingURL=ZoomOut.js.map